// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import T5quicksearch from './T5quicksearch'
import VueTranslator from './plugins/VueTranslator'

Vue.config.productionTip = false

$(function() {

    // load the translation terms JS
    var lang = $('html').attr('lang') || 'de';
    var t;
    
    $.getJSON('/t5quicksearch/translation?lang=' + lang, 
                (data) => {t = data})
        .fail(function() {
             t = {
                'locale': 'en',
                'location-region': 'Location/Region',
                'date-format': 'EEE, dd.MM.yyyy',
                'guests': 'Guests',
                'adult': 'Adult',
                'adults': 'Adults',
                'child': 'Child',
                'children': 'Children',
                'children-age-label': 'Age of child on departure day',
                'unit-add': 'Add unit',
                'unit-delete': 'Remove this unit',
                'unit-set': 'Set',
                'search': 'Search',
                'location': 'Location',
                'region': 'Region',
                'location-not-found': 'no matching location found!',
                'date-cancel' : 'Cancel',
                'date-ok': 'Ok',
                'arrival': 'Checkin date',
                'departure': 'Checkout date'
            };          
        })
        .always(function() {
            Vue.use(VueTranslator, t);
            
            window.initT5SearchBar = (el) => {
                return new Vue({
                  components: { T5quicksearch },
                  template: '<T5quicksearch/>'
                });
            };
            window.searchBars = [];
            
        }); 
});
 
/* eslint-disable no-new */

// Mount the application into a container using:
//   vm.$mount('#tosc5-quicksearch');
   
// Create a shortcut to the T5quicksearch component:
// var t5 = vm.$children[0];

// Then it is possible to modify it's properties dynamically:
// t5.units = 1;
// t5.adults = 2;
// t5.dates.checkin = '2020-06-16';
// t5.dates.checkout = '2020-06-30';
// t5.target = 'https://www.kaernten.at/de/unterkunft-buchen/';
// or
// t5.target = '#t5-target-id';
// t5.startSearch();



// WEBPACK FOOTER //
// ./src/main.js